"use strict";
import DocumentTypeSetter from "./document_type_setter";
import WaitingSpinner from "../waiting_spinner";
import DisablingButton from "../../components/disabling_button";
import Api from "../../api/api";
import ReactUtils from "../../react_utils";
var bem = ReactUtils.makeBem("document-types");
export default React.createClass({
  getInitialState: function() {
    return {
      updating: false,
      doctypeChanged: false,
      types: {},
      prevSelectedDocument: this.props.model.selectedDocument
    };
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.updating }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", { className: bem("__main-heading") }, "Identify The Documents ", this.completionButtons()), this.possibleGroupingFailures(), this.selector()));
  },
  componentDidMount: function(argument) {
    if (this.groupingErrorExists()) {
      const doc = this.documentsWithGroupingErrors()[0];
      this.props.model.selectPage(doc.pages[0]);
    }
  },
  selector: function() {
    return /* @__PURE__ */ React.createElement(
      DocumentTypeSetter,
      {
        document: this.props.model.selectedDocument,
        documentTypesTransformer: this.props.documentTypesTransformer,
        handleEnterPress: this.handleEnterPress,
        onTypeSet: this.typeWasSet
      }
    );
  },
  possibleGroupingFailures: function() {
    if (this.groupingErrorExists()) {
      return _.map(this.groupingErrors(), this.groupingErrorDisplay);
    }
  },
  groupingErrors: function() {
    return _.uniq(_.flatten(_.map(
      this.documentsWithGroupingErrors(),
      (d) => {
        return d.data["grouping_errors"] || [];
      }
    )));
  },
  groupingErrorDisplay: function(error) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution document-types__grouping-alert" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: bem("__grouping-error-title") }, /* @__PURE__ */ React.createElement("b", null, "Grouping Error:\xA0")), this.groupingErrorTitle(error)), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: bem("__grouping-error-title") }, /* @__PURE__ */ React.createElement("b", null, "Possible Solutions:")), this.possibleSolutions(error)));
  },
  possibleSolutions: function(error) {
    let errorToSolutions = {};
    errorToSolutions["back_to_back_invoices"] = this.backToBackInvoiceSolutions();
    errorToSolutions["does_not_start_with_allowed_document_type"] = this.doesNotStartWithAllowedTypesSolutions();
    return errorToSolutions[error];
  },
  groupingErrorTitle: function(error) {
    let errorToTitle = {};
    errorToTitle["back_to_back_invoices"] = this.backToBackInvoiceTitle();
    errorToTitle["does_not_start_with_allowed_document_type"] = this.doesNotStartWithAllowedTypesTitle();
    return errorToTitle[error];
  },
  doesNotStartWithAllowedTypesTitle: function() {
    return "This group does not start with allowed types. Allowed types before the first carrier invoice are: Statement Invoice, Notice of Assignment, Funding Form, Internal Documents - Other";
  },
  backToBackInvoiceTitle: function() {
    return "This group has 2 or more consecutive carrier invoices.";
  },
  doesNotStartWithAllowedTypesSolutions: function() {
    return /* @__PURE__ */ React.createElement("ul", { className: bem("__solutions-list") }, /* @__PURE__ */ React.createElement("li", null, this.fixTypeSolution()), /* @__PURE__ */ React.createElement("li", null, this.skipAutoGroupingSolutionText()));
  },
  backToBackInvoiceSolutions: function() {
    return /* @__PURE__ */ React.createElement("ul", { className: bem("__solutions-list") }, /* @__PURE__ */ React.createElement("li", null, "If there is a 2 page invoice, merge pages together."), /* @__PURE__ */ React.createElement("li", null, this.fixTypeSolution()), /* @__PURE__ */ React.createElement("li", null, this.skipAutoGroupingSolutionText()));
  },
  fixTypeSolution: function() {
    return "If a document type is incorrect, fix the document type.";
  },
  skipAutoGroupingSolutionText: function() {
    if (this.props.documentIndexerService._allDocumentsHaveGroups()) {
      return "If document types are correct, skip auto-grouping.";
    } else {
      return "If pages are out of order go on to manual grouping.";
    }
  },
  documentsWithGroupingErrors: function() {
    if (this.props.documentBatch) {
      return _.filter(this.props.documentBatch.documents, (d) => {
        return (d.data["grouping_errors"] || []).length > 0;
      });
    } else {
      return [];
    }
  },
  groupingErrorExists: function() {
    return this.documentsWithGroupingErrors().length > 0;
  },
  shouldUpdateGrouping: function() {
    if (this.props.documentBatch) {
      const firstGroup = this.props.documentBatch.document_groups && this.props.documentBatch.document_groups[0];
      if (firstGroup) {
        return firstGroup.grouping_method !== "manual";
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  completionButtons: function() {
    if (this.shouldUpdateGrouping()) {
      return /* @__PURE__ */ React.createElement("span", null, this.updateGroupingButton(), this.possibleManualGroupingButton(), this.possibleSkipAutoGroupingButton());
    } else {
      return this.doneButton();
    }
  },
  handleEnterPress: function(suggestedType) {
    if (this.shouldUpdateGrouping()) {
      var docs = this.props.model.allDocuments();
      var remaining = _.reject(docs, _.property("type"));
      if (remaining.length === 0) {
        this.updateGroupsAndContinue();
      } else {
        if (suggestedType) {
          this.typeWasSet(this.props.model.selectedDocument, suggestedType.value, suggestedType.name);
        }
      }
    } else {
      this.clearGroupingErrors();
    }
  },
  possibleManualGroupingButton: function() {
    if (this.groupingErrorExists() && !this.props.documentIndexerService._allDocumentsHaveGroups()) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          className: "button--progress right " + bem("__update-and-continue-button"),
          disabled: this.state.updating,
          disabledText: "Saving...",
          onClick: this.clearGroupingErrors
        },
        "Group Manually"
      );
    }
  },
  possibleSkipAutoGroupingButton: function() {
    if (this.props.documentIndexerService._allDocumentsHaveTypes() && this.props.documentIndexerService._allDocumentsHaveGroups()) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          className: "button--progress right " + bem("__update-and-continue-button"),
          disabled: this.state.updating,
          disabledText: "Saving...",
          onClick: this.clearGroupingErrors
        },
        "Continue"
      );
    }
  },
  clearGroupingErrors() {
    const ids = _.map(this.documentsWithGroupingErrors(), (d) => d.id);
    if (ids.length > 0) {
      this.setState({ updating: true });
      this.props.documentIndexerService.clearGroupingErrors(ids).then(this.advanceStep).catch(() => {
        this.setState({ updating: false });
      });
    } else {
      this.advanceStep();
    }
  },
  doneButton: function() {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--progress right " + bem("__update-and-continue-button"),
        onClick: this.clearGroupingErrors
      },
      "Continue Without Updating Groups"
    );
  },
  updateGroupingButton: function() {
    if (this.props.documentIndexerService._allDocumentsHaveTypes()) {
      if (this.state.doctypeChanged || !this.props.documentIndexerService._allDocumentsHaveGroups()) {
        return /* @__PURE__ */ React.createElement(
          DisablingButton,
          {
            className: "button--progress right " + bem("__update-and-continue-button"),
            disabled: this.state.updating,
            disabledText: "Saving...",
            onClick: this.updateGroupsAndContinue
          },
          "Update Grouping"
        );
      }
    } else {
      var docs = this.props.model.allDocuments();
      var remaining = _.reject(docs, _.property("type"));
      var d = remaining === 1 ? "Document" : "Documents";
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button",
          disabled: "true"
        },
        "(",
        remaining.length,
        ") ",
        d,
        " Remaining "
      );
    }
  },
  // Need to differentiate here if the type is set for proofOfDelivery/postal
  // then we need to do things special.
  typeWasSet: function(document, type, type_name) {
    if (!document.data.podFlagSetByUser) {
      document.is_pod = _.contains(
        ["proofOfDelivery", "postal"],
        type
      ) && !Api.Account.currentSettings().only_manual_pod;
      document.data.includesPOD = document.is_pod;
    }
    document.type = type;
    document.type_name = type_name;
    var types = this.state.types;
    types[document.id] = type;
    this.setState({ types, doctypeChanged: true });
    var doc = this.props.model.nextIncompleteDocument();
    if (doc && !this.props.stayOnPageAfterSetting) {
      this.props.model.selectPage(doc.pages[0]);
    }
    this.props.onUpdate(document, type);
  },
  updateGroupsAndContinue: function() {
    if (this.groupsWereManuallyRegrouped() || this.props.documentIndexerService._hiddenDocumentsExist()) {
      let dialogue = ["Are you sure you would like to re-run grouping?"];
      if (this.groupsWereManuallyRegrouped()) {
        dialogue.push("You have manually edited groups via the 'Group Documents' step. Re-grouping will permanently revert those changes.");
      }
      if (this.props.documentIndexerService._hiddenDocumentsExist()) {
        dialogue.push("You have hidden documents in the batch. Re-grouping will permanently delete the hidden documents.");
      }
      let confirmed = confirm(dialogue.join("\n\n"));
      if (!confirmed) {
        return;
      }
    }
    this.setState({ updating: true });
    if (this.props.isForced) {
      var page = this.state.prevSelectedDocument.pages[0];
      this.props.model.selectPage(page);
    } else {
      this.props.model.selectPage(null);
    }
    this.props.documentIndexerService.updateDocumentGroups(this.props.documentBatch.id).then(this.advanceStep).catch(() => {
      this.setState({
        updating: false
      });
    });
  },
  groupsWereManuallyRegrouped: function() {
    var _a;
    let groups = this.props.model.groups;
    if (!groups) {
      return false;
    }
    return ["manual_regroup", "manual_rearrange"].includes((_a = groups[0]) == null ? void 0 : _a.grouping_method);
  },
  advanceStep: function() {
    this.props.onComplete();
    if (this.isMounted()) {
      this.setState({ updating: false, types: {} });
    }
    return null;
  }
});
